<template>
  <el-container>
    <el-header height="90px">
       <div class="header">
            <a href="#" title="返回中国传媒大学首页" class="t-logo">
              <img src="../images/logo.png" border="0" />
            </a>
            <span class="el-span">新生网上选床系统</span>
            <div id="rightheader" v-if="username != null">
              <table>
                <tr>
                  <td><el-avatar icon="el-icon-user-solid"></el-avatar></td>
                  <td>
                    <span class="el-username">{{ username }}</span>
                  </td>
                  <td>
                    <el-button size="mini" round @click="Logout()"
                      >退出</el-button
                    >
                  </td>
                </tr>
              </table>
            </div>
          </div>
    </el-header>
    <el-main>
        <div class="opt">   
      <el-row>
        <el-col :span="2">
          <div class="grid-content"></div>
        </el-col>
        <el-col :span="13">
          <div class="grid-content bg-purple-light">
             <div style="overflow: auto;height:100%;"> 
             <p v-html="info.data" >
              
             </p>
             </div>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="grid-content bg-purple">
              <div class="login-wrapper">
          <el-form :model="form" label-width="80px">
            <span style="text-align:center">
              <h3>欢迎新同学！</h3>
            </span>
            <el-form-item label="身份证号">
              
              <el-input
                v-model="form.loginname" 
                placeholder="请输入身份证号"
              >
              <template #suffix>
                <i class="el-input__icon el-icon-user"></i>
              </template>
              </el-input>
              
          
            </el-form-item>
            <el-form-item label="密  码">
              <el-input
                v-model="form.password" type="password"
                placeholder="请输入密码"
              >
                <template #suffix>
                <i class="el-input__icon el-icon-more-outline"></i>
              </template>
              </el-input>
            </el-form-item>
             <el-button
              v-if="info.isopen==true"
              class="el-button-cuc"
              @click="onSubmit(form)"
              v-text="form.logtext"
            ></el-button>
            <p style="white-space: pre-wrap;text-align:left;"
              v-html="info.txt"
              v-if="info.isopen==false"
            ></p>
             <p class="browser">
									<span style="float:left;color:#606266;font-size:14px;">建议浏览器：</span>
									<a class="firefox_pic" target="_blank" href="http://www.firefox.com.cn/download/">火狐</a>
									<a class="google_pic" target="_blank" href="https://www.google.cn/chrome/">谷歌</a>
								</p>
          </el-form>
         
        </div>

          </div>
        </el-col>
        <el-col :span="2">
          <div class="grid-content"></div>
        </el-col>
      </el-row>
      </div>
    </el-main>
    <el-footer style="height: 5vh">
      <div class="login-copyright">
        Copyright © {{ new Date().getFullYear() }} 中国传媒大学 All Rights
        Reserved.
      </div>
    </el-footer>
  </el-container>
</template>
<style scoped>
.el-container{
  background: url("../images/bg-body.jpg") repeat;
}
.el-main {
  min-height: 84vh;
  background: url("../images/bg-login.jpg")  top center no-repeat;
 background-repeat: no-repeat;
 background-size: cover;
 padding: 0;
}
.opt{
    margin-top: 8vh;   
    color: #000;
}
.bg-purple-light{
    line-height: 20px;
    text-align: left;
    padding-left: 20px;
    
    background-color: #fff; 
    opacity: 0.8;height: 60vh;
    
}
.bg-purple-light p {
  padding-top:15px ;
  padding-right:10px ;
}
.bg-purple{ 
    text-align: left;
    border: 1px;
    color: #000;height: 60vh;
}
.login-copyright{
    text-align: center;
    position: relative;
    z-index: 1;
    line-height: 40px;
}

.login-wrapper {
  width: 100%;
  padding: 0px 10px;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  z-index: 2;
  height: 60vh;
}

.login-wrapper > .el-form {
  padding: 25px 20px;
  background-color: #fff;
  box-shadow: 0 3px 6px -1px rgba(7, 6, 6, 0.19);
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #c0c4cc;
  height: 60vh;
}

.login-wrapper > .el-form > h2 {
  color: #333;
  font-size: 18px;
  text-align: center;
  margin-bottom: 25px;
}

.login-wrapper > .el-form > .el-form-item {
  margin-bottom: 25px;
  position: relative;
}

.login-wrapper > .el-form > .el-form-item:last-child {
  margin-bottom: 0;
}

.login-wrapper > .el-form > .el-form-item > .el-input {
  height: 46px;
  line-height: 46px;
  border-radius: 2px !important;
}

.login-wrapper .el-input-icon-group > .el-input {
  padding-left: 46px;
}

.login-wrapper .el-input-icon-group > .el-icon {
  width: 46px;
  height: 46px;
  line-height: 46px;
  font-size: 20px;
  color: #909399;
  position: absolute;
  left: 0;
  top: 0;
  text-align: center;
}

.login-wrapper > .el-form > .el-form-item.login-captcha-group {
  padding-right: 135px;
}

.login-wrapper > .el-form > .el-form-item.login-captcha-group > .login-captcha {
  height: 46px;
  width: 120px;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid #e6e6e6;
  border-radius: 2px !important;
  position: absolute;
  right: 0;
  top: 0;
}

.login-wrapper > .el-form > .el-form-item > .el-form-checkbox {
  margin: 0 !important;
  padding-left: 25px;
}

.login-wrapper > .el-form > .el-form-item > .el-form-checkbox > .el-icon {
  width: 15px !important;
  height: 15px !important;
}

.login-wrapper > .el-form .el-btn-fluid {
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  border-radius: 2px !important;
}

.login-wrapper > .el-form > .el-form-item.login-oauth-group > a > .el-icon {
  font-size: 26px;
}
.el-button-cuc,.el-button-cuc:hover,.el-button-cuc:focus{

	background-image:none;
	background-color:#059490;
	width: 100%;
	line-height: 1;
	padding:10px 0;
	cursor: pointer;
	border:1px solid #04726f;
	font-family:"Microsoft YaHei";
	font-size:16px;
	height:50px;
	line-height:30px;
	border-radius:6px;
	margin: 8px 0 0 0;
	color:#fff;
	text-align:center;
	position:relative;
	box-sizing: border-box;
}
.browser {
  margin: 15px 60px;
}
.browser a {
  background-repeat: no-repeat;
  color: #666;
  float: left;
  font-family: "Microsoft YaHei UI";
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  margin: 0 0 0 10px;
  padding: 0 0 0 25px;
}
.firefox_pic {
  background-image: url("../images/firefox-pic.png");
}

.google_pic {
  background-image: url("../images/google-pic.png");
}
.elheader {
  background: url("../images/bg-body.jpg") repeat center center;
}
.header {
  max-width: 1380px;
  margin: 0 auto;
  clear: both;
  padding: 0px 50px;
}
.t-logo {
  float: left;
  margin: 13px 18px 0 0;
}
#rightheader {
  float: right;
  height: 60px;
}
.el-span {
  line-height: 90px;
  font-size: 22px;
  font-weight: bold;
  float: left;
}
</style>
<script>
import { reactive } from "vue";
import { defineComponent } from "vue";
import { ElMessage } from "element-plus";
import { login } from "../http/api.ts";
import { getInfoBaseByType } from "../http/api.ts";
import Route from "../router/index";
import { GetWebSiteSet } from "@/http/api";
import { GetSetTime } from "@/http/api";
export default defineComponent({
  name: "Login",

  setup() {
    let form = reactive({
      loginname: "",
      password: "",
      logtext: "登 录",
    });
    let info = reactive({
      data: "",
      txt:"",
      isopen:false
    });
    let dataFun = async () => {
      await GetSetTime().then((res) => {
        if(res.datas){
          info.isopen=true;        
        }else {
          info.isopen=false;    
        }
      });
       await GetWebSiteSet().then((res) => {        
          info.txt=res.datas.openDesc;    
      });
      await getInfoBaseByType("11").then((res) => {
        info.data = res.datas.description;
      });
     
    };   
    dataFun();
    return {
      form,
      info,
    };
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入身份证号", tigger: "change" }],
      },
    };
  },
  mounted() {
    if (this._isMobile()) {
      Route.push("/m?tmsite="+Math.random());
    }
    
  },
  methods: {
    onSubmit(form) {
      if (form.loginname == "" || form.password == "") {
        ElMessage.error({message:"身份证号和密码不能为空！",offset: 300});
        return;
      }
      form.logtext = "登录中...";
      const loading = this.$loading({
        lock: true,
        text: "登录中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      login(form).then((res) => {
        if (res.code == 202||res.code == 200) {
          
          localStorage.setItem("userToken", "Bearer " + res.token);
          localStorage.setItem("username", res.datas.student_Name);
          if (res.msg == "已选房") {
            this.$alert(
              "您已完成选床操作，请认真阅读《中国传媒大学学生公寓住宿协议书》，打印《中国传媒大学学生公寓住宿信息确认表》和《国传媒大学学生公寓住宿协议书》，本人签字确认并粘贴一寸照片，办理入住手续时交于公寓管理人员。",
              "提示",
              {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确定",
                callback: () => {
                  Route.push("/view?tmsite=" + Math.random());
                },
              }
            );
          } else {
            ElMessage.success({message:res.msg,offset: 300});
            setTimeout(function () {
              Route.push("read?tmsite="+Math.random());
            }, 1000);
          }
        } else {
          this.$alert(res.msg, {
            dangerouslyUseHTMLString: true,
          });
        }
        form.logtext = "登 录";
        loading.close();
      });
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
});
</script>